<template>
    <div>
        <button @click="showModal" :class="buttonStyle === false ? 'link link--is-button link--secondary save-configuration__link' : 'btn btn--primary btn--full-width save-configuration__button'">Save configuration</button>

        <SaveConfigurationModal ref="saveConfigurationModal" />
    </div>
</template>

<script>
import SaveConfigurationModal from "./SaveConfigurationModal.vue";

export default {
    props: {
        buttonStyle: {
            type: Boolean,
            required: false,
            default: false,
        },
        customEvent: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        SaveConfigurationModal,
    },
    methods: {
        showModal: function () {
            this.$refs.saveConfigurationModal.openModal(this.customEvent);
        },
    },
};
</script>

<style lang="scss">
.save-configuration__button {
    &::before {
        display: inline-block;
        content: "";
        background-image: url("/images/outline-heart-configurator-white.svg");
        background-size: 18px 18px;
        width: 18px;
        height: 18px;
        transform: translateY(3px);
        margin-right: 10px;
    }
}

.save-configuration__link {
    text-align: center;
    display: block;
    margin: 30px auto;

    &::before {
        display: inline-block;
        content: "";
        background-image: url("/images/outline-heart-configurator.svg");
        background-size: 20px 20px;
        width: 20px;
        height: 20px;
        transform: translateY(5px);
        margin-right: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/SaveConfiguration.vue